import { View } from './view';
import { Translations } from '../config/translations';

export class DiscountView extends View {

  discountInput: HTMLInputElement | undefined;
  discountTrigger: HTMLElement | undefined;

  discountFormContainer: HTMLElement =  document.createElement('div');

  renderDiscountCodeForm(applyDiscount: any) {
    this.discountFormContainer.classList.add('hs-form', 'stacked', 'df-f', 'df-f-discount');
    this.discountFormContainer.innerHTML = `<fieldset class='form-columns-2 df-discount-area df-fieldset' style='display: flex;'>
             <div class='field hs-form-field df-field' style="flex-grow: 1;">
               <label>
                 <span class='df-f-label' data-label="discount_code">${Translations.DISCOUNT_CODE}</span>
               </label>
               <div class='input'>
                 <input type='text' id='df-discount-code' name='df-discount-code' class='hs-input df-input' autocomplete='off'/>
               </div>
             </div>
             <div class='field hs-form-field df-apply-discount-holder df-apply-discount df-field'>
               <a id='df-apply-discount-btn' class='df-f-apply-discount' data-label="apply_discount">${Translations.APPLY_DISCOUNT}</a>
             </div>
            </fieldset>
            <div id='df-discount-success-result' style='display: block;'></div>
            <div id='df-discount-error-result' style='display: block;'></div>
            <div id='df-discount-trial-days' style='display: block;'></div>`;
    const container = this.getDFContainer();
    container.appendChild(this.discountFormContainer);
    this.discountInput = this.getInputElement('#df-discount-code');
    this.discountTrigger = this.getHtmlElement('#df-apply-discount-btn');
    this.discountTrigger.onclick = applyDiscount;
  }

  assignDiscountFromUrl(code: string) {
    if (this.discountInput) {
      this.discountInput.value = code;
      if (this.discountTrigger) {
        this.discountTrigger.click();
      }
    }
  }

  setDiscountSuccessResult(result: string) {
    const successDiscountResult = this.getHtmlElement('#df-discount-success-result');
    const errorDiscountResult = this.getHtmlElement('#df-discount-error-result');
    successDiscountResult.innerText = result;
    this.hide(errorDiscountResult);
    this.show(successDiscountResult);
  }

  setDiscountErrorResult(result: string) {
    const successDiscountResult = this.getHtmlElement('#df-discount-success-result');
    const errorDiscountResult = this.getHtmlElement('#df-discount-error-result');
    errorDiscountResult.innerText = result;
    this.hide(successDiscountResult);
    this.show(errorDiscountResult);
  }

  showDiscountTrialDays(result: string) {
    const discountTrialDaysElement = this.getHtmlElement('#df-discount-trial-days');
    discountTrialDaysElement.innerText = result;
    this.show(discountTrialDaysElement);
  }

  show(element: any) {
    element.style.display = 'block';
  }

  hideDiscountTrialDays() {
    const discountTrialDaysElement = this.getHtmlElement('#df-discount-trial-days');
    discountTrialDaysElement.innerText = '';
    this.hide(discountTrialDaysElement);
  }

  getTotal(): number {
    const totalChar = document.getElementById('df-final-amount');
    if (totalChar) {
      return parseInt(totalChar.innerText.replace(/^\D+/g, ''), 10) || 0;
    }
    return 0;
  }

  showForm() {
    this.discountFormContainer.style.display = 'initial';
  }

  hideForm() {
    this.discountFormContainer.style.display = 'none';
  }

}
